<div class="datepicker" *ngIf="!!showPanel">
	<div class="date-label">{{label}}</div>
	<div id="title" class="label">{{formattedDate}}</div>
	<div class="block action" (click)="addMonth(1)"><i class="fa fa-plus"></i></div>
	<div class="block action" (click)="addDay(1)"><i class="fa fa-plus"></i></div>
	<div class="block action" (click)="addYear(1)"><i class="fa fa-plus"></i></div>
	<div></div>
	<div class="block middle" id="month">{{month}}</div>
	<div class="block middle" id="day">{{day}}</div>
	<div class="block middle" id="year">{{year}}</div>
	<div></div>
	<div class="block action" (click)="addMonth(-1)"><i class="fa fa-minus"></i></div>
	<div class="block action" (click)="addDay(-1)"><i class="fa fa-minus"></i></div>
	<div class="block action" (click)="addYear(-1)"><i class="fa fa-minus"></i></div>

	<div class="timepicker">
		<div class="time-block">
			<div class="action" (click)="incrementHour()">&#9650;</div>
			<div class="value">{{ hour | number: '2.0' }}</div>
			<div class="action" (click)="decrementHour()">&#9660;</div>
		</div>

		<span>:</span>

		<div class="time-block">
			<div class="action" (click)="incrementMinute()">&#9650;</div>
			<div class="value">{{ minute | number: '2.0' }}</div>
			<div class="action" (click)="decrementMinute()">&#9660;</div>
		</div>

		<div class="am-pm-toggle">
			<div class="action" (click)="togglePeriod()">{{ period }}</div>
		</div>
	</div>

	<div class="action-row">
		<div class="action" (click)="cancel()">Cancel</div>
		<div class="action" (click)="reset()">Reset</div>
		<div class="action" (click)="confirm()">OK</div>
	</div>

</div>